import { memo } from "react";

import type { ButtonType } from "@similarweb/ui-components";
import { Button } from "@similarweb/ui-components";

import { isTrial } from "app/UtilitiesAndConstants/UtilityFunctions/trialUsersUtils";
import { swSettings } from "app/common/services/swSettings";
import { translate } from "app/filters/i18nFilter";

import { upgradeButtonKey } from "./dataAutomationKeys";
import * as SC from "./styles";
import { texts } from "./texts";

type UserPackageSchema = {
    className?: string;
    buttonType?: ButtonType;
    dataAutomation?: string;
    onClick?: () => void;
};

export const UserPackage = memo(({ className, buttonType = "flat", dataAutomation, onClick }: UserPackageSchema) => {
    const upgradeUrl = `${swSettings.swsites.login}${swSettings.components.HookWorkspace.resources.UserSubscriptionsUrl}`;

    const isTrialUser = isTrial();

    return (
        <SC.StyledContainer data-automation={dataAutomation}>
            <SC.StyledButtonsContainer>
                {!isTrialUser ? (
                    <div className={className}>
                        <a
                            onClick={onClick}
                            href={upgradeUrl}
                            target="_blank"
                            rel="noreferrer"
                            data-automation={upgradeButtonKey}
                        >
                            <Button type={buttonType}>{translate(texts.manageButton)}</Button>
                        </a>
                    </div>
                ) : null}
            </SC.StyledButtonsContainer>
        </SC.StyledContainer>
    );
});

UserPackage.displayName = "UserPackage";
